import React, { useMemo } from "react";
import styled from "styled-components";
import get from "lodash/get";
import { head, without } from "lodash";
import { getOwners } from "../../helpers/utils";

const SPACE_BETWEEN_ICON = 10;
const X_MARGIN = 10;
const ICON_SIZE = 18;

const RelatedContacts = ({ contacts = [] }) => {
  const { owners, subtitle } = useMemo(() => {
    const owners = getOwners(contacts);
    const firstOwner = head(owners);

    const ownerName = `${get(firstOwner, ["firstName"])} ${get(firstOwner, [
      "name",
    ])}`;
    const remainingContact = without(contacts, firstOwner);

    const subtitle = contacts.length
      ? `${ownerName} ${
          !!remainingContact.length
            ? ` et ${remainingContact.length} autre(s) personne(s)`
            : ""
        }`
      : "Aucun contact";

    return {
      owners,
      subtitle,
    };
  }, [contacts]);

  const computeIconContainerWidth = () => {
    if (owners.length === 0) return 0;
    return (
      (ICON_SIZE - SPACE_BETWEEN_ICON) * owners.length +
      SPACE_BETWEEN_ICON +
      X_MARGIN
    );
  };

  const computeLeftPosition = (index) =>
    SPACE_BETWEEN_ICON * (owners.length - index);

  return (
    <StyleWrapper className="d-flex align-item-center justify-content-between">
      <div>
        <p className="title">Contacts associés</p>
        <p className="subtitle">{subtitle}</p>
      </div>
      <div
        className="position-relative"
        style={{
          width: `${computeIconContainerWidth()}px`,
        }}
      >
        {owners.reverse().map((_, i) => (
          <i
            key={i}
            className="account-icon position-absolute bi bi-person-circle"
            style={{
              left: `${computeLeftPosition(i)}px`,
            }}
          />
        ))}
      </div>
    </StyleWrapper>
  );
};

const StyleWrapper = styled.div`
  border: 1px solid var(--menu-active-color);
  border-radius: var(--radius-container);
  padding: 4px 7px;

  .title {
    color: var(--text-color);
    font-size: 11px;
    font-weight: 700;
    margin: 0;
  }

  .subtitle {
    color: var(--light-grey-text);
    font-size: 8px;
    margin: 0;
  }

  .account-icon::before {
    position: absolute;
    color: var(--toolbar-button-color);
    border: 1px solid var(--white);
    border-radius: 50%;
    background-color: var(--white);
    top: 3px;
  }
`;

export default RelatedContacts;
